
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M10.13 21.073h6.505v3.237H10.13zM17.549 21.073h6.505v3.237h-6.505zM24.968 21.073h6.505v3.237h-6.505zM32.387 21.073h6.505v3.237h-6.505zM10.13 25.224h6.505v3.237H10.13zM17.549 25.224h6.505v3.237h-6.505zM24.968 25.224h6.505v3.237h-6.505zM32.387 25.224h6.505v3.237h-6.505zM10.13 29.374h6.505v3.237H10.13zM17.549 29.374h6.505v3.237h-6.505zM24.968 29.374h6.505v3.237h-6.505zM32.387 29.374h6.505v3.237h-6.505zM10.13 33.524h6.505v3.237H10.13zM17.549 33.524h6.505v3.237h-6.505zM24.968 33.524h6.505v3.237h-6.505zM32.387 33.524h6.505v3.237h-6.505z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M6 18.001h36.001"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"square","d":"M35.807 12H42.5v27.781H6.5V12h6.865m15.906 0h-9.587"}}),_c('rect',{attrs:{"width":"3","height":"7","x":"15.001","y":"8.5","stroke":"#234652","rx":"1.5"}}),_c('rect',{attrs:{"width":"3","height":"7","x":"31.002","y":"8.5","stroke":"#234652","rx":"1.5"}})])
          )
        }
      }
    